import Schedule from "../../components2026/Schedule.jsx";
import Poster from "../../images/poster.jpeg"




const EventDetails = () => {

    return (
        <div className="schedule m-5 text-2xl">
            <Schedule />
        </div>
    );
}
export default EventDetails;
